import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "@/components/atoms";
import { useLazyVerifyProviderQuery } from "@/redux/apis/auth/authApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setKindeConfig } from "@/redux/slices/config/configSlice";
import { siteInfoSelector } from "@/redux/slices/config/selectors";
import { setActiveOperator } from "@/redux/slices/operator/operatorSlice";

export const OperatorSignUp = () => {
  const { register } = useKindeAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const siteInfo = useAppSelector(siteInfoSelector);
  const [verify] = useLazyVerifyProviderQuery();

  useEffect(() => {
    // Wait for siteInfo to be fully loaded (not empty object)
    if (!siteInfo?.key) {
      return;
    }

    // Check if the site/domain is multi-tenant
    if (!siteInfo.isMultiTenant) {
      // Single tenant site cannot register new operators
      navigate("/404");
      return;
    }

    // Multi-tenant site allows operator registration
    // Fetch and set the domain operator as active
    verify({ providerCode: siteInfo.key, apiUrl: siteInfo.apiUrl })
      .unwrap()
      .then((res) => {
        if (res.kindeIssuerUrl && res.kindeClientId) {
          dispatch(setKindeConfig({ domain: res.kindeIssuerUrl, clientId: res.kindeClientId }));
        }
        dispatch(setActiveOperator(res));

        // Redirect to Kinde registration with domain as campaign
        register({
          properties: {
            utm_campaign: siteInfo.key,
            utm_source: "web-app",
            utm_content: "operator",
          },
        });
      })
      .catch(() => {
        // If operator not found, redirect to 404
        navigate("/404");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteInfo?.key]);

  // Show loading while redirecting
  return <Loading />;
};
